import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { observer } from 'mobx-react-lite'

import FormsStore from 'stores/forms'
import { useStore } from 'hooks'
import { THEME } from 'utils'

import TeamSearchAndSelect from 'components/TeamSearchAndSelect'

const FavoriteTeamsSchema = Yup.object().shape({
  NFL: Yup.array().of(Yup.string().trim().min(1)),
  MLB: Yup.array().of(Yup.string().trim().min(1)),
  NBA: Yup.array().of(Yup.string().trim().min(1)),
  NHL: Yup.array().of(Yup.string().trim().min(1)),
  NCAA: Yup.array().of(Yup.string().trim().min(1))
})

const FavoriteTeamsForm = () => {
  const router = useRouter()
  const formsStore = useStore(FormsStore)
  const [stickyState, setStickyState] = useState(false)

  // override the behavior on 'Enter' Keypress so it doesn't submit the form while the user searches
  useEffect(() => {
    const handleKeyPress = (e) => {
      const { key } = e
      if (key === 'Enter') {
        e.preventDefault()
        return false
      }
    }
    window.addEventListener('keypress', handleKeyPress)
    return () => window.removeEventListener('keypress', handleKeyPress)
  }, [])

  const handleSubmit = ({ NFL, MLB, NBA, NHL, NCAA }) => {
    // add info to the forms store
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NFL teams?',
      answer: NFL
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite MLB teams?',
      answer: MLB
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NBA teams?',
      answer: NBA
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NHL teams?',
      answer: NHL
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NCAA teams?',
      answer: NCAA
    })

    router.push('/barstool-sportsbook/casino-games')
  }

  const handleSkip = () => {
    // add empty array answers for skipping
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NFL teams?',
      answer: []
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite MLB teams?',
      answer: []
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NBA teams?',
      answer: []
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NHL teams?',
      answer: []
    })
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite NCAA teams?',
      answer: []
    })

    router.push('/barstool-sportsbook/casino-games')
  }

  return (
    <>
      <Formik
        initialValues={{
          NFL: [],
          MLB: [],
          NBA: [],
          NHL: [],
          NCAA: []
        }}
        validationSchema={FavoriteTeamsSchema}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form className='sportsBookForm'>
            <div className='teamSelectContainer'>
              <TeamSearchAndSelect
                mobileStickySearchBar
                nonMobileStickySearchBar
                onSelectionsUpdate={(teamsByLeague) => {
                  setFieldValue('NFL', teamsByLeague.NFL)
                  setFieldValue('MLB', teamsByLeague.MLB)
                  setFieldValue('NBA', teamsByLeague.NBA)
                  setFieldValue('NHL', teamsByLeague.NHL)
                  setFieldValue('NCAA', teamsByLeague.NCAA)
                }}
                onViewAllStatusChange={(viewAllStatus) => setStickyState(viewAllStatus)}
              />
            </div>
            <div className='buttonGroup'>
              <button type='submit' className='sportsBook__submitButton'>
                Continue
              </button>
              <button className='sportsBook__submitButton sportsBook__secondaryButton' onClick={handleSkip}>
                Skip
              </button>
            </div>
          </Form>
        )}
      </Formik>
      <style jsx>{`
        .buttonGroup {
          position: ${stickyState ? 'sticky' : 'relative'};
          width: 100%;
          left: auto;
          bottom: 0;
          padding: 0;
          background: #fff;
        }
        .teamSelectContainer {
          margin-bottom: 0;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .teamSelectContainer {
            min-height: 600px;
          }
        }
      `}</style>
    </>
  )
}

export default observer(FavoriteTeamsForm)
